module.exports = __webpack_public_path__ + "static/media/heart_item6f3026cc5f51e159d8ec1a0c73e71051.webp";